import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';
import { BusinessSearch, Business } from '../../models/finance/business';

@Injectable({
  providedIn: 'root',
})
export class BusinessProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/business';

  public search(
    businessSearch: BusinessSearch,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder = -1,
    matchAny = false,
  ): Observable<ApiResponse<PaginatedApiResponse<Business>>> {
    let url = `${this.baseUrl}/search?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (sortField) {
      url += `&sortField=${encodeURIComponent(sortField)}&sortOrder=${sortOrder}`;
    }
    if (matchAny) {
      url += `&matchAny=true`;
    }

    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Business>>>(url, businessSearch);
  }

  public getById(id: string): Observable<ApiResponse<Business>> {
    return this.httpClient.get<ApiResponse<Business>>(`${this.baseUrl}/${id}`);
  }

  public getByIds(ids: string[]): Observable<ApiResponse<Business[]>> {
    return this.httpClient.post<ApiResponse<Business[]>>(`${this.baseUrl}/batch/ids`, ids);
  }

  public setLotNumbers(id: string, lotNumbers: string[]): Observable<ApiResponse<object>> {
    return this.httpClient.patch<ApiResponse<object>>(`${this.baseUrl}/${id}/lot-numbers`, {
      lotNumbers,
    });
  }
}
